<template>
  <el-dialog
    class="dialog"
    title="批量选择报名期次"
    width="50%"
    :visible.sync="showBatchModal.flag"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    distroy-on-close
    @close="closeDialog"
  >
    <div class="main-contant">
      <el-form :model="filters" size="small">
        <el-form-item>
          <el-select
            v-model="filters.periodId"
            placeholder="请选择报名期次"
          >
            <el-option
              v-for="(item) in periodList"
              :key="item.periodId"
              :label="item.periodName"
              :value="item.periodId">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog" size="small">取消</el-button>
      <el-button type="primary" size="small" @click="submit">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    showBatchModal: {
      type: Object,
      default: () => {
        return {
          flag: false,
        };
      },
    },
    periodList: {
      type: Array,
      default() {
        return [];
      },
    }
  },
  data() {
    return {
      dialogVisible: false,
      filters: {
        periodId: ""
      },
    };
  },
  // created() {
  //   vue.$on("showBatchOperate", () => {
  //     this.dialogVisible = true;
  //   });
  // },
  // beforeDestroy() {
  //   vue.$off("showBatchOperate");
  // },
  methods: {
    closeDialog() {
      this.$emit("closeBatchModal");
    },
    submit() {
      this.$emit("ChangePeriodId", this.filters.periodId);
      this.$emit("closeBatchModal");
    }
  },
};
</script>
